export enum BillingStatus {
  BILLED = "BILLED",
  TO_BILL = "TO_BILL",
  MISSING_PO = "MISSING_PO",
  WITHOUT = "WITHOUT",
  PAID = "PAID",
  DELETED = "DELETED",
}
